import { Link } from "react-router-dom";

export const StatCard = ({ label, value, sub, icon: Icon, accent = false, testId, to }) => {
  const inner = (
    <div className="relative">
      <div className="flex items-start justify-between gap-2">
        <p className="stat-label break-words">{label}</p>
        {Icon && (
          <span className={`w-8 h-8 rounded-md border flex items-center justify-center shrink-0 transition-colors duration-200 group-hover:border-[var(--cc-accent)]/50 ${accent ? "border-[var(--cc-accent)]/40 bg-[var(--cc-accent)]/10" : "bg-secondary/60"}`}>
            <Icon className={`w-4 h-4 ${accent ? "text-[var(--cc-accent)]" : "text-muted-foreground group-hover:text-[var(--cc-accent)] transition-colors duration-200"}`} />
          </span>
        )}
      </div>
      <p className="mt-3 text-2xl sm:text-3xl font-heading font-extrabold tracking-tight break-words">{value}</p>
      {sub && <p className="mt-1.5 text-xs text-muted-foreground break-words">{sub}</p>}
    </div>
  );

  const cls = `group card-lift rounded-xl border bg-card p-4 sm:p-5 min-w-0 transition-all duration-200 hover:border-[var(--cc-accent)]/50 hover:shadow-[0_0_0_1px_var(--cc-accent),0_8px_28px_-12px_var(--cc-accent)] ${accent ? "corner-cc border-[var(--cc-accent)]/45" : ""} ${to ? "cursor-pointer" : ""}`;

  if (to) return <Link to={to} data-testid={testId} className={`block ${cls}`}>{inner}</Link>;
  return <div data-testid={testId} className={cls}>{inner}</div>;
};
